import { useState, useEffect } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { baseurladdress } from '../baseurl';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Alert } from 'react-bootstrap';




export default function AddBranch() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const Swal = require('sweetalert2');
    let navigate = useNavigate();


    const [hidden, sethidden] = useState(true);
    const [cntry_name, setcntry_name] = useState([]);
    const [state_name, setstate_name] = useState([]);
    const [district_name, setdistrict_name] = useState([]);
    const [region_name, setregion_name] = useState([]);


    const [Branchname, setBranchname] = useState("");
    const [Branchcode, setBranchcode] = useState("");
    const [Branchregion, setBranchregion] = useState("");
    const [Branchphone, setBranchphone] = useState("");
    const [Branchmobile, setBranchmobile] = useState("");
    const [Branchemail, setBranchemail] = useState("");
    const [Branchpassword, setBranchpassword] = useState("");
    const [Branchcin, setBranchcin] = useState("");
    const [Branchcoordinates, setBranchcoordinates] = useState("");
    const [nablchechk, setnablchechk] = useState("0");
    const [Branchplace, setBranchplace] = useState("");
    const [Branchaddress, setBranchaddress] = useState("");
    const [Branchcountry, setBranchcountry] = useState("");
    const [Branchstate, setBranchstate] = useState("");
    const [Branchdistrict, setBranchdistrict] = useState("");
    const [Branchpincode, setBranchpincode] = useState("");



    //SUBMIT BRANCH 👇

    const handleSubmit = (event) => {

        event.preventDefault();
        const data = {

            branch_name: Branchname,
            branch_code: Branchcode,
            branch_region: Branchregion,
            branch_phones: Branchphone,
            branch_mobile: Branchmobile,
            branch_email: Branchemail,
            branch_password: Branchpassword,
            branch_cinnumber: Branchcin,
            branch_coordinate: Branchcoordinates,
            branch_nabl: nablchechk,
            branch_place: Branchplace,
            branch_resultaddress: Branchaddress,
            branch_country: Branchcountry,
            branch_state: Branchstate,
            branch_district: Branchdistrict,
            branch_pin: Branchpincode,
            userid: accessuserid
        };


        fetch(
            baseurladdress + `addbranch`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "success") {

                    //alert("Branch added successfully");
                    // window.location.href = "/branchlist";
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Branch added successfully'
                    })

                    navigate("/branchlist");

                }
                else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Error'
                    })


                }

            });
    };





    //FETCH COUNTRY,STATE,DISTRICT 👇


    useEffect(() => {
        const getcountry = () => {
            axios.get(baseurladdress + `getallcountries`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    // console.log(data);
                    const user = data.map((item, index) => {
                        return (
                            <option value={item.cntry_id}> {item.cntry_name} </option>
                        )
                    }
                    );
                    setcntry_name(user);
                }).catch(error => {
                    alert(error);
                })
        }
        getcountry()


        const getRegions = () => {
            axios.get(baseurladdress + `getallregions`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    // console.log(data);
                    const user = data.map((item, index) => {
                        return (
                            <option value={item.region_id}> {item.region_name} </option>
                        )
                    }
                    );
                    setregion_name(user);
                }).catch(error => {
                    alert(error);
                })
        }
        getRegions()
    }, [])



    const changeTitle = (staffcntry) => {
        axios.get(baseurladdress + `getstates/` + staffcntry, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                // console.log(data);
                const user = data.map((item, index) => {
                    return (
                        <option value={item.state_id}> {item.state_name} </option>
                    )
                }
                );
                setstate_name(user);
            }).catch(error => {
                alert(error);
            })
    }


    const changeDistricts = (staffdistrict) => {
        axios.get(baseurladdress + `getdistricts/` + staffdistrict, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                // console.log(data);
                const user = data.map((item, index) => {
                    return (
                        <option value={item.district_id}> {item.district_name} </option>
                    )
                }
                );
                setdistrict_name(user);
            }).catch(error => {
                alert(error);
            })
    }


    //CHECHK BOX 👇

    const handlenabl = (event) => {
        var checked = event.target.checked;

        if (checked == true) {
            setnablchechk("1");
        }
        else {
            setnablchechk("0");
        }
        //alert(checked+nablchechk);
    };


    //TOOGLE PASSWORD 👇

    const hideandshow = () => {
        var x = document.getElementById("user_pass");
        if (x.type === "password") {
            x.type = "text";
            sethidden(false);
        } else {
            x.type = "password";
            sethidden(true);
        }
    }

    //CHECK BRANCHNAME IF ALREADY EXISTS 👇


    const CheckBranchName = () => {
        const data = {
            branchname: Branchname,
        };
        fetch(
            baseurladdress + `checkexistbranchname`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "exist") {

                    //alert("Branch added successfully");
                    // window.location.href = "/branchlist";
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Branch Name Already Exists Please Change'
                    })
                }
            });
    };

    //CHECK BRANCHCODE IF ALREADY EXISTS 👇


    const CheckBranchCode = () => {

        const data = {
            branch_code: Branchcode,
        };
        fetch(
            baseurladdress + `checkexistbranchcode`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "exist") {

                    //alert("Branch added successfully");
                    // window.location.href = "/branchlist";
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Branch Code Already Exists Please Change'
                    })
                }
            });
    };


    return (
        <>
            <Sidennav />
            <Topnavbar />

            <div class="content-wrap">
                <div className="container-fluid">

                    <div className="col-md-2 ">
                        <NavLink activeClassName="active-link" to={"/branchlist"}>
                            <div style={{ display: "flex" }}>
                                <a class="float ">
                                    <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                                </a>
                            </div>
                        </NavLink>

                    </div>

                    <form
                        onSubmit={handleSubmit}
                    >
                        <div className='row'>
                            <div className='row'>

                                <div class="col-xl-6 col-xxl-12" >
                                    <div class="card">
                                        <div class="card-header">
                                            <h4 class="card-title">ADD BRANCH </h4>
                                        </div>

                                        <div class="card-body">
                                            <div class="basic-form" >

                                                <div class="form-row">

                                                    <div class="col-sm-12">
                                                        <h6>Branch name </h6>
                                                        <input type="text" class="form-control"
                                                            onChange={(e) => setBranchname(e.target.value)}
                                                            required />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6> Code </h6>
                                                        <input type="text" class="form-control"
                                                            onChange={(e) => setBranchcode(e.target.value)}
                                                            onClick={() => CheckBranchName()}
                                                            required />
                                                    </div>


                                                    <div className="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Password </h6>
                                                        <div className="input-group mb-3">
                                                            <input

                                                                className="form-control "
                                                                name="userpass"
                                                                id="user_pass" type="password"
                                                                onChange={(e) => setBranchpassword(e.target.value)}
                                                                onClick={() => {
                                                                    CheckBranchCode();
                                                                    CheckBranchName();
                                                                }}
                                                                required
                                                            />
                                                            <div className="input-group-append">
                                                                <div className="input-group-text"
                                                                    onClick={() => {
                                                                        hideandshow();

                                                                    }}>
                                                                    <span
                                                                        class="fa fa-eye text-info"
                                                                        style={{ cursor: "pointer" }}
                                                                        id="togglePassword"

                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Phone </h6>
                                                        <input class="form-control"
                                                            onChange={(e) => setBranchphone(e.target.value)}
                                                            pattern="[0-9]+" maxLength="14" />
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Mobile </h6>
                                                        <input class="form-control"
                                                            onChange={(e) => setBranchmobile(e.target.value)}
                                                            pattern="[0-9]+" maxLength="14" />
                                                    </div>


                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Email </h6>
                                                        <input type="email" class="form-control"
                                                            onChange={(e) => setBranchemail(e.target.value)}
                                                        />
                                                    </div>

                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Region </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Region"
                                                            id="employee"
                                                            placeholder="Enter Role"
                                                            onChange={(e) => setBranchregion(e.target.value)}
                                                        >

                                                            <option value="" disabled selected>
                                                                select
                                                            </option>
                                                            {region_name}
                                                        </select>

                                                    </div>




                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>CIN Number </h6>
                                                        <input type="text" class="form-control"
                                                            onChange={(e) => setBranchcin(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Co-ordinates </h6>
                                                        <input type="text" class="form-control"
                                                            onChange={(e) => setBranchcoordinates(e.target.value)}
                                                        />
                                                    </div>
                                                    <br></br>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <input type="checkbox" name="nabl" className="selectsingle checku" value={1}
                                                            onClick={handlenabl}

                                                            style={{ cursor: "pointer" }}
                                                        />
                                                        <label className="form__label textal offset-1" for="clienttype">
                                                            NABL ?
                                                        </label>

                                                    </div>

                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-xxl-12">
                                    <div class="card">

                                        <div class="card-body">

                                            <div class="basic-form">

                                                <div class="form-row">


                                                    <div class="form-group col-md-12">
                                                        <h6>Alternate Address </h6>
                                                        <textarea class="form-control text alternativeaddress"
                                                            onChange={(e) => setBranchaddress(e.target.value)}
                                                        />
                                                    </div>



                                                  
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Country </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Country"
                                                            onChange={e => { changeTitle(e.target.value); setBranchcountry(e.target.value) }}

                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {cntry_name}
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>State </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="State"

                                                            onChange={e => { changeDistricts(e.target.value); setBranchstate(e.target.value) }}
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {state_name}

                                                        </select>
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>District </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="District"
                                                            onChange={(e) => setBranchdistrict(e.target.value)}
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {district_name}
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Place </h6>
                                                        <input class="form-control text textplace"
                                                            onChange={(e) => setBranchplace(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Pin </h6>
                                                        <input type="text" class="form-control"
                                                            onChange={(e) => setBranchpincode(e.target.value)}
                                                            maxLength="6" />
                                                    </div>

                                                    <div class="col-12 offset-5" style={{ "marginTop": "35px" }}>
                                                        <button type="submit" class="btn btn-primary mb-2"  >Submit</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div >


                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>

    )
}
